import { render, staticRenderFns } from "./InvoiceScan.vue?vue&type=template&id=363a656a&scoped=true&"
import script from "./InvoiceScan.vue?vue&type=script&lang=js&"
export * from "./InvoiceScan.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceScan.vue?vue&type=style&index=0&id=363a656a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363a656a",
  null
  
)

export default component.exports